export default "__VITE_ASSET__839575c6__"